import { Grid } from "@material-ui/core";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip, Cell, LabelList } from "recharts";
import { groupBy } from "lodash";
import { exceptionCountsWidgetStyle } from "./style";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import { sortBy } from "lodash";
import { useGetLoadStatusReasonsQuery } from "features/loads/loadsSlice";
import React, { useState } from "react";
import ExportButton from "components/ExportButton/ExportButton";
import { IconDownloadFile, IconTruck } from "icons";
import { loadStatusReasonOwnerObj } from "../loadsDashboardConsts";
import LoadsListDialog from "../LoadsListDialog";
import { loadStatuses } from "features/loads/enums";

const ExceptionBarChart = ({ loads, statuses }) => {
    const classes = exceptionCountsWidgetStyle();

    let { data: statusReasons, error: statusReasonsError, isLoading: isLoadingStatusReasons } = useGetLoadStatusReasonsQuery();
    statusReasons = statusReasons || [];
    statusReasons = statusReasons.filter(sr => statuses?.includes(sr.statusId));

    const [selectedBar, setSelectedBar] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    let loadsByReasons = groupBy(loads, 'reasonId');

    let finalData = sortBy(statusReasons.map(sr => ({
        ...sr,
        count: loadsByReasons[sr.id]?.length ?? 0,
        loads: loadsByReasons[sr.id] ?? []
    })), [d => d.owner]);

    const CustomTooltip = ({ payload }) => {
        return (
            <div className={classes.graphTootltip}>
                <p>
                    <div style={{ fontSize: 11 }}>{statuses?.includes(loadStatuses.EXCEPTION) ? 'Exception' : 'Cancellation'}</div>
                    <div style={{ fontSize: 10 }}><b>{payload?.[0]?.payload?.reasonText}</b></div>
                    <div style={{ color: loadStatusReasonOwnerObj?.[payload?.[0]?.payload?.owner]?.color }}><b>{payload?.[0]?.payload?.count}</b></div>
                </p>
            </div>
        );
    };

    const CustomTick = ({ x, y, payload }) => {
        const value = payload.value.length > 15 ? `${payload.value.slice(0, 15)}...` : payload.value;
        const lines = [];
        for (let i = 0; i < value.length; i += 6) {
            lines.push(value.slice(i, i + 6));
        }

        return (
            <text x={x} y={y} dy={20} textAnchor="center" fontSize="0.4em" fontWeight="600" fill="#787777">
                {lines.map((line, index) => (
                    <tspan key={index} x={x} dy={index === 0 ? 5 : 10} dx={-9}>
                        {line}
                    </tspan>
                ))}
            </text>
        );
    };

    const onClickBar = (data) => {
        setSelectedBar(data);
        setOpenDialog(true);
    }

    const mapExportData = (a => {
        return {
            ['Reason']: a.reasonText,
            ['Owner']: `${loadStatusReasonOwnerObj?.[a.owner]?.name}`,
            ['Count']: a.count
        };
    })

    const CustomTitle = () => {
        return <div className={classes.dialogTitleWrapper}>
            <div className={classes.dialogTitle}>
                <IconTruck />
                {statuses?.includes(loadStatuses.EXCEPTION) ? 'Exception' : 'Cancelled'} Loads ({selectedBar?.count})
            </div>
            <div className={classes.dialogSubTitle}>Reason: <b style={{ color: loadStatusReasonOwnerObj?.[selectedBar?.owner]?.color }}>{selectedBar?.reasonText}</b></div>
        </div>
    }

    return <Grid item style={{ height: 340, position: 'relative' }}>
        <div style={{ position: 'absolute', top: '-1.5em', right: '0.5em' }}>
            <ExportButton
                btnStyle='text'
                label=""
                icon={<IconDownloadFile />}
                fileLabel="Export"
                data={finalData}
                mapExportData={mapExportData}
            />
        </div>
        {!!finalData?.length ?
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={finalData}
                    margin={{ top: 50, right: 20, left: -40, bottom: 10 }}
                >
                    <XAxis
                        type="category"
                        axisLine={false}
                        interval={~~(finalData?.length / 40)}
                        dataKey="reasonText"
                        tickLine={false}
                        tick={<CustomTick />}
                    />
                    <YAxis
                        type="number"
                        dataKey="count"
                        axisLine={false}
                        tickLine={false}
                        tick={{
                            fontSize: '0.75em',
                            fill: '#787777',
                        }}
                        tickFormatter={(value) => Math.round(value) == value ? value : ''}
                    />
                    <Tooltip
                        content={<CustomTooltip />}
                        cursor={{ fill: '#F3F5F6' }}
                    />
                    <Bar
                        dataKey="count"
                        maxBarSize={6}
                        cursor="pointer"
                        onClick={(data) => onClickBar(data)}
                    >
                        {finalData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={loadStatusReasonOwnerObj?.[entry.owner]?.color} />
                        ))}
                        <LabelList dataKey="count" position="top" style={{ fontSize: 10, fill: '#787777' }} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
            : <EmptyPlaceholder text='No Loads' />}
        <LoadsListDialog
            loads={selectedBar?.loads}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            title={<CustomTitle />}
        />
    </Grid>
}
export default ExceptionBarChart;